export const isValidDomain = (domain: string) => {
  // eslint-disable-next-line no-useless-escape
  const regex = new RegExp(/^[^,](((?!-))(xn--|_{1,1})?[a-z0-9-]{0,61}[a-z0-9]{1,1}\.)*(xn--)?([a-z0-9][a-z0-9\-]{0,60}|[a-z0-9-]{1,30}\.[a-z]{2,})$/);
  return regex.test(domain.toLowerCase());
};
